import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import EmployeeTable from "../../DataTables/Workforce/Employees/EmployeeTable";
import { CRUDPermissions } from "../../../Types/Common/Access";

interface UserAccessProps {
  access: CRUDPermissions;
}

const EmployeeContainer: React.FC<UserAccessProps> = ({ access }) => {
  return (
    <>
      <Breadcrumbs mainTitle="Employee Directory" parent="Workforce" />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <EmployeeTable access={access} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default EmployeeContainer;
